import { cn } from "@/lib/utils";
import { useTheme } from "next-themes";

import { m } from "@/paraglide/messages";
import { DarkIcon, LightIcon } from "../icons/header";
import { CardTooltip } from "../ui/card-tooltip";

export function ThemeToggle({
	className,
	...props
}: React.HTMLAttributes<HTMLButtonElement>) {
	const { setTheme, theme } = useTheme();

	const nextTheme = theme === "dark" ? "light" : "dark";

	return (
		<CardTooltip
			className="min-w-32"
			trigger={
				<button
					className={cn("cursor-pointer", className)}
					onClick={() => setTheme(nextTheme)}
					title="切换主题"
					{...props}
				>
					{theme === "dark" ? (
						<DarkIcon className="w-5.5 h-5.5 hover:[&>path]:!fill-main1 dark:[&>path]:fill-t1" />
					) : (
						<LightIcon className="w-5.5 h-5.5 hover:[&>path]:!fill-main1 dark:[&>path]:fill-t1" />
					)}
				</button>
			}
			label={
				<div className="">
					{m.switch_theme({
						theme:
							nextTheme === "dark"
								? m.switch_theme_dark()
								: m.switch_theme_light(),
					})}
				</div>
			}
		/>
	);
}
